import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import { computed, set } from '@ember/object';
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import currency from 'beebee-base/lib/currency-core';
import { normalizeCurrency, escapeHtml } from 'beebee-base/lib/utility';
import { cached, tracked } from '@glimmer/tracking';
import { inject } from '@ember/service';
import { _saveAll, _safeReload, _sortedCustomFields } from '../lib/utility.js';
import { typeOf } from '@ember/utils';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42;
let PaymentModel = (_dec = attr('boolean'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('boolean', {
  defaultValue: false
}), _dec6 = attr('string'), _dec7 = attr('number', {
  currency: true
}), _dec8 = attr('number'), _dec9 = attr('string'), _dec0 = hasMany('invoice', {
  inverse: null,
  async: true
}), _dec1 = hasMany('expense', {
  inverse: null,
  async: true
}), _dec10 = hasMany('contact', {
  inverse: null,
  async: true
}), _dec11 = hasMany('product', {
  inverse: null,
  async: true
}), _dec12 = hasMany('project', {
  inverse: null,
  async: true
}), _dec13 = hasMany('event', {
  inverse: null,
  async: true
}), _dec14 = attr('string'), _dec15 = attr('boolean'), _dec16 = attr('string'), _dec17 = attr('string'), _dec18 = attr('string'), _dec19 = attr('string'), _dec20 = attr('string'), _dec21 = attr('string'), _dec22 = attr('string'), _dec23 = attr('string'), _dec24 = attr('string'), _dec25 = attr('string'), _dec26 = computed('_tmpVoucher', 'voucher'), _dec27 = attr('string'), _dec28 = computed('_tmpOption', 'option'), _dec29 = hasMany('custom_field', {
  inverse: null,
  async: false
}), _dec30 = belongsTo('assurance', {
  inverse: null,
  async: false
}), _dec31 = hasMany('file', {
  inverse: null,
  async: true
}), _dec32 = attr('number', {
  defaultValue: 0
}), _dec33 = attr('number', {
  defaultValue: 0
}), _dec34 = attr('number', {
  defaultValue: 0
}), _dec35 = attr('number', {
  defaultValue: 0
}), _dec36 = attr('number', {
  defaultValue: 0
}), _dec37 = attr('number', {
  defaultValue: 0
}), _dec38 = attr('number', {
  defaultValue: 0
}), _dec39 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec40 = attr('boolean', {
  defaultValue: false
}), _class = class PaymentModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "log", _descriptor3, this);
    _initializerDefineProperty(this, "checked", _descriptor4, this);
    _initializerDefineProperty(this, "archivied", _descriptor5, this);
    _initializerDefineProperty(this, "created_at", _descriptor6, this);
    _initializerDefineProperty(this, "date", _descriptor7, this);
    _initializerDefineProperty(this, "data_valuta", _descriptor8, this);
    _initializerDefineProperty(this, "sent", _descriptor9, this);
    _initializerDefineProperty(this, "status", _descriptor0, this);
    _initializerDefineProperty(this, "total", _descriptor1, this);
    _initializerDefineProperty(this, "residuo", _descriptor10, this);
    _initializerDefineProperty(this, "payment_method", _descriptor11, this);
    _initializerDefineProperty(this, "invoices", _descriptor12, this);
    _initializerDefineProperty(this, "expenses", _descriptor13, this);
    _initializerDefineProperty(this, "contacts", _descriptor14, this);
    _initializerDefineProperty(this, "products", _descriptor15, this);
    _initializerDefineProperty(this, "projects", _descriptor16, this);
    _initializerDefineProperty(this, "events", _descriptor17, this);
    _initializerDefineProperty(this, "error", _descriptor18, this);
    _initializerDefineProperty(this, "success", _descriptor19, this);
    _initializerDefineProperty(this, "transaction_type", _descriptor20, this);
    _initializerDefineProperty(this, "transaction_id", _descriptor21, this);
    _initializerDefineProperty(this, "transaction_ref", _descriptor22, this);
    _initializerDefineProperty(this, "currency", _descriptor23, this);
    _initializerDefineProperty(this, "payment_id", _descriptor24, this);
    _initializerDefineProperty(this, "enr_status", _descriptor25, this);
    _initializerDefineProperty(this, "auth_status", _descriptor26, this);
    _initializerDefineProperty(this, "tran_bank_id", _descriptor27, this);
    _initializerDefineProperty(this, "notes", _descriptor28, this);
    _initializerDefineProperty(this, "voucher", _descriptor29, this);
    _initializerDefineProperty(this, "option", _descriptor30, this);
    _initializerDefineProperty(this, "custom_fields", _descriptor31, this);
    _initializerDefineProperty(this, "assurance", _descriptor32, this);
    _initializerDefineProperty(this, "files", _descriptor33, this);
    _initializerDefineProperty(this, "total_files_number", _descriptor34, this);
    _initializerDefineProperty(this, "total_contacts_number", _descriptor35, this);
    _initializerDefineProperty(this, "total_products_number", _descriptor36, this);
    _initializerDefineProperty(this, "total_projects_number", _descriptor37, this);
    _initializerDefineProperty(this, "total_expenses_number", _descriptor38, this);
    _initializerDefineProperty(this, "total_invoices_number", _descriptor39, this);
    _initializerDefineProperty(this, "total_events_number", _descriptor40, this);
    _initializerDefineProperty(this, "current_users", _descriptor41, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor42, this);
  }
  get idArray() {
    return [this.id];
  }
  saveAll(model) {
    return _saveAll(model, this.session, 'payments_all');
  }
  safeReload() {
    return _safeReload(this);
  }
  get voucher_json() {
    if (this._tmpVoucher) {
      return this._tmpVoucher;
    } else if (!this.voucher) {
      return null;
    }
    try {
      return JSON.parse(this.voucher);
    } catch (e) {
      this.log.error(e);
      return null;
    }
  }
  set voucher_json(value) {
    set(this, '_tmpVoucher', value);
  }
  get option_json() {
    if (this._tmpOption) {
      return this._tmpOption;
    } else if (!this.option) {
      return null;
    }
    try {
      return JSON.parse(this.option);
    } catch (e) {
      this.log.error(e);
      return null;
    }
  }
  set option_json(value) {
    set(this, '_tmpOption', value);
  }
  get scontrini() {
    if (!this.option_json || !this.option_json.scontrini || !Array.isArray(this.option_json.scontrini)) {
      return [];
    }
    return this.option_json.scontrini
    //.filter(s => !s.originale_data)
    .map(s => {
      // Calcolo del totale sommando i prezzi in righe_scontrino
      const totale = (Array.isArray(s.righe_scontrino) ? s.righe_scontrino : [])?.reduce((acc, riga) => acc + (Number.parseFloat(riga.price) || 0), 0) || 0;

      // Formattazione della valuta
      const currency = this.currency || this.session?.option_field?.intl?.currency || 'EUR';
      const formattedCurrency = normalizeCurrency(currency);
      const formattedTotal = this.intl.formatNumber(totale, {
        style: 'currency',
        currency: formattedCurrency
      });
      return {
        // s.numero comes from stored option_json: escape it because
        // consumers render this label as raw HTML (triple-curly).
        label: `${s.stornato ? '<span class="label small">STORNATO</span>' : ''} ${s.reso ? '<span class="label small">RESO</span>' : ''} ${s.originale_data && !s.reso ? '<span class="label small">STORNO</span>' : ''} ${escapeHtml(s.numero) || ''}`,
        sub_label: `${formattedTotal} - ${s.registratoreRT?.name || ''} #${s.registratoreRT?.seriale || ''}`,
        item: s
      };
    });
  }
  get lastScontrino() {
    const scontrini = this.scontrini || [];
    return scontrini.length ? scontrini[scontrini.length - 1] : null;
  }
  get sorted_custom_fields() {
    let fields;
    try {
      fields = this.custom_fields;
    } catch {
      return [];
    }
    if (Array.isArray(fields)) {
      return _sortedCustomFields(fields, this.isDeleted);
    }
    if (fields && typeof fields.then === 'function') {
      return fields.then(resolvedFields => _sortedCustomFields(resolvedFields, this.isDeleted));
    }
    return [];
  }
  get current_users_label() {
    return this.current_users.map(user => user.label).join(' ');
  }
  get normalizedTotal() {
    return this.sent ? this.total * -1 : this.total;
  }
  get icon() {
    const icon = this.sent ? 'square-arrow-up-right' : 'square-arrow-down-left';
    const color = this.sent ? 'payment-sent' : 'payment-received';
    return {
      icon,
      color
    };
  }
  get label() {
    let number = this.total || 0;
    const valuta = this.currency || this.session?.option_field?.intl?.currency || 'EUR';
    const formattedCurrency = normalizeCurrency(valuta);
    if (typeOf(number) === 'string') {
      const options = number.includes(',') ? {
        decimal: ','
      } : {};
      number = currency(number, options).value;
    }
    const formattedTotal = this.intl.formatNumber(number, {
      style: 'currency',
      currency: formattedCurrency
    });
    const paymentMethod = this.payment_method ? ` ${this.payment_method}` : '';
    return `${formattedTotal}${paymentMethod}`;
  }
  get sub_label() {
    const timeZone = this.session.me?.time_zone || 'Europe/Rome';
    const dateObject = this.date ? new Date(this.date) : null;
    if (dateObject && !isNaN(dateObject.getTime())) {
      const start_date = this.intl.formatDate(dateObject, {
        timeZone: timeZone
      });
      const start_hour = this.intl.formatTime(dateObject, {
        timeZone: timeZone,
        hour: 'numeric',
        minute: 'numeric'
      });
      return `${start_date} ${start_hour}`;
    }
    return null;
  }
  get thumbnail_icon() {
    return {
      icon: this.sent ? 'square-arrow-up-right' : 'square-arrow-down-left',
      class: this.success ? 'text-success' : 'text-alert'
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "log", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "checked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "archivied", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "date", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "data_valuta", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "sent", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "total", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "residuo", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "payment_method", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "invoices", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "expenses", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "products", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "projects", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "events", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "error", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "success", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "transaction_type", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "transaction_id", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "transaction_ref", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "currency", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "payment_id", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "enr_status", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "auth_status", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "tran_bank_id", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "voucher", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "voucher_json", [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, "voucher_json"), _class.prototype), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "option", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "option_json", [_dec28], Object.getOwnPropertyDescriptor(_class.prototype, "option_json"), _class.prototype), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "custom_fields", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sorted_custom_fields", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sorted_custom_fields"), _class.prototype), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "assurance", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "total_files_number", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "total_contacts_number", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "total_products_number", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "total_projects_number", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "total_expenses_number", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "total_invoices_number", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "total_events_number", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "current_users", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { PaymentModel as default };
//# sourceMappingURL=payment.js.map
